import React from 'react';
import spice from '../assets/spice.jpg';

import fssaiLogo from '../assets/fssai.png';
import isoLogo from '../assets/iso.webp';
import '../styles/quality.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

function Quality() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

 const fadeInUp = {
  initial:{ opacity: 0, y: 40 },
  animate:{ opacity: 1, y: 0 },
  transition:{ duration: 0.8 }
};
const fadeInUp2 = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: true, amount: 0.2 }
};


  return (
    <div>
      <div
        className='bg'
        style={{
          backgroundImage: `url(${spice})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
        }}
      >
        <div className="qa-container">
          <div {...fadeInUp} className='cardtitle1'>
          <motion.h1  {...fadeInUp} className="qa-title">
            {t('qa_commitment_title')}
          </motion.h1>

          <motion.p {...fadeInUp} className="qa-intro">
            {t('qa_commitment_intro')}
          </motion.p>
</div>
<div className='cardtitle'>
          <motion.section {...fadeInUp} className="qa-section">
            <h2>{t('product_quality_section_title')}</h2>
            <p>
              {t('product_quality_section_description_part1')}<br /><br />
              {t('product_quality_section_description_part2')}
            </p>
          </motion.section>
</div>
<div className='cardtitle'>
          <motion.section {...fadeInUp2} className="qa-section">
            <h2>{t('packaging_sachet_quality_title')}</h2>
            <p>{t('packaging_sachet_quality_description_part1')}</p>
            <p>{t('packaging_sachet_quality_description_part2')}</p>
          </motion.section>
</div>
<div className='cardtitle'>
          <motion.section {...fadeInUp2} className="qa-section">
            <h2>{t('what_you_experience_title')}</h2>
            <ul>
              <li>{t('experience_smell_authenticity')}</li>
              <li>{t('experience_taste_richness')}</li>
              <li>{t('experience_feel_purity')}</li>
            </ul>
            <p>{t('papilla_delivers_experience')}</p>
            <p>
              {t('transparency_you_can_trust_title')}<br />
              {t('transparency_you_can_trust_description')}<br />
              {t('quality_proven_tagline')}
            </p>
          </motion.section>
</div>
          <section className="qa-cards">
            <div className="qa-card">
              <motion.div {...fadeInUp2}>
              <img src={fssaiLogo} alt={t('fssai_logo_alt')} className="cert-logo1" />
              <h3>{t('fssai_certified_card_title')}</h3>
              <p>{t('fssai_certified_card_description')}</p>
              <p><strong>{t('license_no')}:</strong> 11225998000317</p>
              </motion.div>
            </div>
            <div className="qa-card">
              <motion.div {...fadeInUp2}>
              <img src={isoLogo} alt={t('iso_logo_alt')} className="cert-logo2" />
              <h3 className='isohead'>{t('iso_certified_card_title')}</h3>
              <p>{t('iso_certified_card_description')}</p>
              <p><strong>{t('certificate_no')}:</strong> ISO/FSMS/987654321</p>
              </motion.div>
            </div>
          </section>

          {/* <motion.section {...fadeInUp2} className="qa-downloads">
            <h2>{t('download_qa_docs')}</h2>
            <ul>
              <li>
                <a href={qaReport} target="_blank" rel="noopener noreferrer">
                  {t('qa_report_pdf')}
                </a>
              </li>
              <li>
                <a href={qaReport} target="_blank" rel="noopener noreferrer">
                  {t('organic_certification_pdf')}
                </a>
              </li>
            </ul>
          </motion.section> */}

          <footer className="qa-footer">
            <p>{t('need_more_info')} <Link to="/contact">{t('contact_for_reports')}</Link></p>
          </footer>
        </div>
      </div>

      <div className='footer'>
        <p className='foot-head'>{t('company_name_full')}</p>
        <p>No: 37/953, 24th Main, JP Nagar II Phase, Bangalore-560078</p>
        <p>{t('all_rights_reserved', { year: currentYear })}</p>
      </div>
    </div>
  );
}

export default Quality;
